module.exports = __webpack_public_path__ + "05_medium_brown.1e76f06e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/05_medium_brown.png
// module id = PxFY
// module chunks = 0